:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileFrameScrollWrapper_4064x_7 {
  position: absolute;
  width: 100%;
  height: 100%; }
  ._mobileFrameScrollWrapper_4064x_7._withShadowExtraSpace_4064x_11 {
    height: calc(100% + 30px);
    top: -15px; }
    ._mobileFrameScrollWrapper_4064x_7._withShadowExtraSpace_4064x_11 ._mobileFrame_4064x_7 {
      height: calc(100% - 30px);
      top: 15px; }
  ._mobileFrameScrollWrapper_4064x_7._withFrameExtraSpace_4064x_17 {
    height: calc(100% + 80px);
    top: -40px; }
    ._mobileFrameScrollWrapper_4064x_7._withFrameExtraSpace_4064x_17 ._mobileFrame_4064x_7 {
      height: calc(100% - 80px);
      top: 40px; }
  ._mobileFrameScrollWrapper_4064x_7 ._mobileFrameScrollContainer_4064x_23 {
    position: absolute;
    overflow-y: scroll;
    width: 100%;
    height: 100%; }
    ._mobileFrameScrollWrapper_4064x_7 ._mobileFrameScrollContainer_4064x_23._mobileFrameScrollContainerFixedMarginTop_4064x_28 {
      overflow-y: hidden;
      width: calc(100% - var(--stage-scrollbar-width)); }
    ._mobileFrameScrollWrapper_4064x_7 ._mobileFrameScrollContainer_4064x_23._mobileFrameScrollContainerWizardPreview_4064x_31 {
      overflow: hidden; }
  ._mobileFrameScrollWrapper_4064x_7 ._mobileFrameScrollCover_4064x_33 {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-right: 17px solid #f7f8f8; }
    ._mobileFrameScrollWrapper_4064x_7 ._mobileFrameScrollCover_4064x_33._mobileFrameScrollCoverFixedMarginTop_4064x_39 {
      border-color: transparent; }
    ._mobileFrameScrollWrapper_4064x_7 ._mobileFrameScrollCover_4064x_33._mobileFrameScrollCoverMobileWizard_4064x_41 {
      display: none; }

._mobileFrame_4064x_7 {
  z-index: 1;
  position: absolute;
  top: 0;
  pointer-events: none;
  width: 320px;
  left: calc((100% - 320px) / 2);
  height: 100%;
  transform-origin: center 0 0;
  transition: 0.3s transform, 0.3s height; }
  ._mobileFrame_4064x_7 ._siteShadow_4064x_54 {
    box-sizing: border-box;
    height: calc(100% + 50px);
    width: calc(100% + 8px);
    left: -4px;
    top: -25px;
    background: none;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.15), 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 18px 0 rgba(0, 0, 0, 0.08);
    border-color: #fff;
    border-style: solid;
    border-width: 25px 4px;
    border-radius: 18px; }
    ._mobileFrame_4064x_7 ._siteShadow_4064x_54._siteShadowSectionsExperience_4064x_66 {
      box-shadow: 0px -1px 8px 2px rgba(0, 0, 0, 0.08), 0px 1px 8px 2px rgba(0, 0, 0, 0.08), 2px 0px 8px 2px rgba(0, 0, 0, 0.08), -2px 0px 8px 2px rgba(0, 0, 0, 0.08); }
    ._mobileFrame_4064x_7 ._siteShadow_4064x_54:before {
      content: '';
      position: absolute;
      top: -1px;
      bottom: -1px;
      left: -1px;
      right: -1px;
      border: solid 1px #dfe5eb; }
  ._mobileFrame_4064x_7 ._mobileFrameTop_4064x_76 {
    display: block;
    top: -25px;
    left: -4px;
    height: 25px;
    width: calc(100% + 8px);
    background: none; }
    ._mobileFrame_4064x_7 ._mobileFrameTop_4064x_76:before, ._mobileFrame_4064x_7 ._mobileFrameTop_4064x_76:after {
      content: '';
      position: absolute;
      top: 50%; }
    ._mobileFrame_4064x_7 ._mobileFrameTop_4064x_76:after {
      left: 50%;
      transform: translate(14px, -50%);
      width: 8px;
      height: 8px;
      border-radius: 50px;
      border: 1px solid #dfe5eb; }
    ._mobileFrame_4064x_7 ._mobileFrameTop_4064x_76:before {
      left: 50%;
      transform: translate(-24px, -50%);
      width: 30px;
      height: 3px;
      border-radius: 2px;
      background-color: #dfe5eb; }
  ._mobileFrame_4064x_7 ._mobileFrameBottom_4064x_101 {
    display: block;
    bottom: -25px;
    left: -4px;
    height: 25px;
    width: calc(100% + 8px);
    background: none; }
  ._mobileFrame_4064x_7._previewMode_4064x_108 ._siteShadow_4064x_54 {
    max-height: calc(100% + 50px); }
  ._mobileFrame_4064x_7:not(._frameless_4064x_110) {
    animation: _mobile-frameless-out-animation_4064x_1 1s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards; }
  ._mobileFrame_4064x_7._frameless_4064x_110 {
    animation: _mobile-frameless-in-animation_4064x_1 1s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards; }
    ._mobileFrame_4064x_7._frameless_4064x_110 ._mobileFrameTop_4064x_76,
    ._mobileFrame_4064x_7._frameless_4064x_110 ._mobileFrameBottom_4064x_101 {
      display: none; }
    ._mobileFrame_4064x_7._frameless_4064x_110 ._siteShadow_4064x_54 {
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      border: none;
      border-radius: 0;
      background: none;
      box-shadow: 0 2px 7px rgba(23, 25, 28, 0.17); }
      ._sections-experience_4064x_132 ._mobileFrame_4064x_7._frameless_4064x_110 ._siteShadow_4064x_54 {
        box-shadow: 0px -1px 8px 2px rgba(0, 0, 0, 0.08), 0px 1px 8px 2px rgba(0, 0, 0, 0.08), 2px 0px 8px 2px rgba(0, 0, 0, 0.08), -2px 0px 8px 2px rgba(0, 0, 0, 0.08); }
      ._mobileFrame_4064x_7._frameless_4064x_110 ._siteShadow_4064x_54:before {
        display: none; }
  @media only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2 / 1), only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2) {
    ._mobileFrame_4064x_7 ._mobileFrameTop_4064x_76 {
      background: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/mobileFrame/phone-top@x2.v5.png") center 0 no-repeat; }
    ._mobileFrame_4064x_7 ._mobileFrameBottom_4064x_101 {
      background: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/mobileFrame/phone-bottom@x2.v5.png") center 0 no-repeat; }
    ._mobileFrame_4064x_7 ._siteShadow_4064x_54 {
      background: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/mobileFrame/phone-bg@x2.v4.png") center 0 repeat-y; } }

@keyframes _mobile-frameless-in-animation_4064x_1 {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

@keyframes _mobile-frameless-out-animation_4064x_1 {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }
